<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">管理コンソール</span>
        </div>
      </div>
      <button class="back-btn" v-on:click="back">← メニューへ戻る</button>
    </header>
    <main class="main-content">
      <div class="white-card">
        <div class="page-head">
          <div>
            <p class="page-kicker">Information publishing</p>
            <h1 class="page-title">お知らせ作成</h1>
            <p class="page-copy">
              配信内容、公開日、プッシュ通知の有無を一画面で整理して登録します。
              まず本文を固め、その後で配信方法を決める流れにしています。
            </p>
          </div>
          <div class="page-badge">
            <span class="page-badge__label">Mode</span>
            <span class="page-badge__value">Info post</span>
          </div>
        </div>

        <form v-on:submit.prevent="create">
          <div class="editor-grid">
            <section class="primary-panel">
              <div class="section-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Content</p>
                    <h2 class="section-title">配信内容</h2>
                  </div>
                </div>

                <div class="field-grid">
                  <div class="form-group">
                    <label class="form-label">タイトル</label>
                    <input
                      v-model="info_title"
                      type="text"
                      class="form-control"
                      required
                      placeholder="お知らせタイトル"
                    />
                  </div>

                  <div class="form-group">
                    <label class="form-label">本文</label>
                    <textarea
                      v-model="info_body"
                      class="form-control form-control--textarea"
                      required
                      placeholder="お知らせ本文"
                    ></textarea>
                  </div>
                </div>
              </div>
            </section>

            <section class="detail-panel">
              <div class="section-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Scheduling</p>
                    <h2 class="section-title">公開設定</h2>
                  </div>
                </div>

                <div class="field-grid">
                  <div class="form-group">
                    <label class="form-label">お知らせ日付</label>
                    <input
                      v-model="issue_date"
                      type="date"
                      pattern="\d\d\d\d\-\d\d\-\d\d"
                      class="form-control"
                      required
                      placeholder="2022-10-01"
                    />
                  </div>

                  <div class="form-group">
                    <label class="form-label">プッシュ通知</label>
                    <select v-model="selectedOption" class="form-control">
                      <option v-for="option in options" :key="option.value" :value="option.value">{{ option.label }}</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label class="form-label">プッシュメッセージ</label>
                    <input
                      v-model="push_body"
                      type="text"
                      class="form-control"
                      required
                      placeholder="プッシュメッセージ"
                    />
                  </div>
                </div>
              </div>

              <div class="section-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Checklist</p>
                    <h2 class="section-title">公開前の確認</h2>
                  </div>
                </div>

                <ul class="summary-list">
                  <li>タイトルは一覧で最初に見えるため、短く明確にします。</li>
                  <li>本文は改行込みでそのまま公開されます。</li>
                  <li>プッシュ通知を使う場合は、短い文面に絞ると伝わりやすくなります。</li>
                </ul>
              </div>
            </section>
          </div>

          <div class="button-row">
            <button type="submit" class="btn-primary">作成</button>
            <button type="button" v-on:click="back" class="btn-secondary">戻る</button>
          </div>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import store from "@/store";

export default {
  data: function () {
    return {
      info_title: "",
      info_body: "",
      issue_date: "",
      push_body: "",
      is_push: "0",
      selectedOption: '0',
      options: [
        { label: 'プッシュ通知しない', value: '0' },
        { label: 'プッシュ通知する', value: '1' },
      ],
    }
  },
  async mounted() {
  },
  methods: {
    create: function () {
      const data = {
        info_title: this.info_title,
        info_body: this.info_body,
        issue_date: this.issue_date,
        push_body: this.push_body,
        is_push: this.selectedOption
      }
      axios.post("/info", data).then((res) => {
        router.push("/infos")
      }).catch((error) => {
        alert(error.response.data.detail);
      });
    },
    back: function () {
      router.push("/menu")
    },
    logout: function () {
      store.dispatch("logout")
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background: #DDE2EC;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
  background: #1E2A3A;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header-brand { display: flex; align-items: center; gap: 12px; }

.brand-mark {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, #4F8EF7, #7C5CFC);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem; font-weight: 800; color: #fff;
}

.brand-info { display: flex; flex-direction: column; line-height: 1.2; }
.brand-name { font-size: 1rem; font-weight: 700; color: #fff; }
.brand-sub  { font-size: 0.68rem; color: #8A9BB0; }

.back-btn {
  padding: 8px 20px; border-radius: 8px;
  border: 1.5px solid #94A3B8; background: transparent;
  color: #94A3B8; font-size: 0.85rem; font-weight: 600;
  cursor: pointer; font-family: inherit;
  transition: background 0.2s, color 0.2s;
}
.back-btn:hover { background: #94A3B8; color: #1E2A3A; }

.main-content {
  max-width: 1180px; margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 12px 30px rgba(15,23,42,0.08);
  padding: 32px 40px;
}

.page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid #E2E8F0;
}

.page-kicker {
  margin: 0 0 8px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748B;
}

.page-title {
  font-size: 1.55rem;
  font-weight: 700;
  color: #1E293B;
  margin: 0;
}

.page-copy {
  max-width: 58ch;
  margin: 12px 0 0;
  color: #64748B;
  font-size: 0.95rem;
  line-height: 1.8;
}

.page-badge {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
  min-width: 120px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
}

.page-badge__label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748B;
}

.page-badge__value {
  font-size: 1rem;
  font-weight: 700;
  color: #0F172A;
}

.editor-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(320px, 0.9fr);
  gap: 24px;
  align-items: start;
}

.primary-panel,
.detail-panel {
  display: grid;
  gap: 20px;
}

.section-card {
  padding: 20px;
  border-radius: 18px;
  background: linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%);
  border: 1px solid #E2E8F0;
}

.section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.section-kicker {
  margin: 0 0 6px;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748B;
}

.section-title {
  margin: 0;
  font-size: 1.08rem;
  font-weight: 700;
  color: #1E293B;
}

.field-grid {
  display: grid;
  gap: 16px;
}

.form-group { margin-bottom: 0; }

.form-label { display: block; font-size: 0.85rem; font-weight: 600; color: #475569; margin-bottom: 6px; }

.form-control {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1.5px solid #CBD5E1;
  font-size: 0.9rem;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-control:focus {
  border-color: #3B82F6;
  box-shadow: 0 0 0 4px rgba(59,130,246,0.12);
}

.form-control--textarea {
  min-height: 200px;
  resize: vertical;
}

.summary-list {
  margin: 0;
  padding-left: 20px;
  color: #475569;
  line-height: 1.8;
  text-align: left;
}

.button-row {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #E2E8F0;
}

.btn-primary {
  padding: 10px 24px; border-radius: 12px; border: none;
  background: #3B82F6; color: #fff;
  font-size: 0.9rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background 0.2s, transform 0.2s;
}
.btn-primary:hover { background: #2563EB; transform: translateY(-1px); }

.btn-secondary {
  padding: 10px 24px; border-radius: 12px;
  border: 1.5px solid #CBD5E1; background: #fff;
  color: #475569; font-size: 0.9rem; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: background 0.2s, transform 0.2s;
}
.btn-secondary:hover { background: #F1F5F9; transform: translateY(-1px); }

@media (max-width: 900px) {
  .page-head,
  .editor-grid {
    grid-template-columns: 1fr;
    flex-direction: column;
  }

  .page-badge {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .top-header {
    padding: 0 16px;
  }

  .main-content {
    padding: 24px 14px 60px;
  }

  .white-card {
    padding: 22px 18px;
  }

  .section-card {
    padding: 16px;
  }

  .button-row {
    flex-direction: column;
  }

  .button-row > * {
    width: 100%;
  }
}
</style>
